import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MapService } from "../../view/services/map.service";
import Zoom from "@arcgis/core/widgets/Zoom";
import Locate from "@arcgis/core/widgets/Locate";
import Home from "@arcgis/core/widgets/Home";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";
import Graphic from "@arcgis/core/Graphic";
import Compass from "@arcgis/core/widgets/Compass";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { HomeComponent } from 'src/app/home/components/home/home.component';

@Component({
  selector: 'app-home-bar',
  templateUrl: './home-bar.component.html',
  styleUrls: ['./home-bar.component.css']
})
export class HomeBarComponent implements OnInit {
  controlZoom: Zoom;
  valorZoom: Number;
  location: Locate;
  home: Home;
  compass: Compass;
  compassRotation: number;

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, public mapService: MapService, public homeComponent: HomeComponent) {
    iconRegistry.addSvgIconInNamespace("homeBar", "compass", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_compass.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "locate", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_locate.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "home", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_home.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "left", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_arrow_left.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "rigth", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_arrow_rigth.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "zoomin", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_add.svg"));
    iconRegistry.addSvgIconInNamespace("homeBar", "zoomout", sanitizer.bypassSecurityTrustResourceUrl("assets/img/SVG/RealGISicon_subtract.svg"));
  }

  ngOnInit(): void {
    this.watchNorth()

    this.controlZoom = new Zoom({
      view: this.mapService.getViewMap()
    });
    // this.valorZoom = this.mapService.getViewMap().zoom;
    this.location = new Locate({
      view: this.mapService.getViewMap(),
      graphic: new Graphic({
        symbol: new PictureMarkerSymbol({
          url: "./assets/img/SVG/RealGISicon_ubication_blue.svg",
          width: "40px",
          height: "40px"
        })
      })
    });
    this.home = new Home({
      view: this.mapService.getViewMap(),
      viewpoint: this.mapService.getViewMap().viewpoint
    });
    this.compass = new Compass({
      view: this.mapService.getViewMap()
    });
  }

  zoomIn() {
    this.controlZoom.zoomIn();
  }

  zoomOut() {
    this.controlZoom.zoomOut();
  }

  changeZoom(value:number) {
    this.mapService.getViewMap().zoom = value;
  }

  locate() {
    this.location.locate();
  }

  goHome() {
    this.home.go();
  }

  resetNorth() {
    this.compass.reset()
  }

  watchNorth() {
    const view = this.mapService.getViewMap()
    reactiveUtils.watch(() => view.rotation, (rotation) => {
      this.compassRotation = rotation
    }
    );
  }

}
